import { render, staticRenderFns } from "./ProjectData.vue?vue&type=template&id=bc74505c&scoped=true&"
import script from "./ProjectData.vue?vue&type=script&lang=js&"
export * from "./ProjectData.vue?vue&type=script&lang=js&"
import style0 from "./ProjectData.vue?vue&type=style&index=0&id=bc74505c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc74505c",
  null
  
)

export default component.exports